import { Accordion, AccordionItem, AccordionButton, AccordionPanel } from "@chakra-ui/react";
import { AddIcon, MinusIcon } from "@chakra-ui/icons";
import { Box, chakra } from "@chakra-ui/react";

export const SchoolerAccordion = () => {
  return (
    <Accordion allowMultiple>
      <AccordionItem borderRadius="0.5rem" border="1px solid #6A7684" bg="#FFF">
        {({ isExpanded }) => (
          <Box
            sx={{
              boxShadow: isExpanded ? "-4px 4px 0px 0px #6A7684" : null,
              borderRadius: isExpanded ? "0.5rem" : null,
            }}
          >
            <chakra.h2>
              <AccordionButton _expanded={{ color: "#9559DE" }}>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  p={2}
                  fontSize="1.1875rem"
                  fontWeight={600}
                  fontFamily="Raleway, sans-serif"
                >
                  How do you verify admitted student profiles?
                </Box>

                {isExpanded ? <MinusIcon fontSize="12px" /> : <AddIcon fontSize="12px" />}
              </AccordionButton>
            </chakra.h2>

            <AccordionPanel pb={4}>
              Authenticity is deeply important to us. College students are asked to upload their
              acceptance letters, which are then manually reviewed and verified by our team. We also
              regularly conduct quality checks, looking through profiles for inconsistencies and
              half-truths. If something in a profile seems questionable (an essay looks familiar or
              a test score is suspiciously low), we ask our admits for further documentation to
              verify their profile. In short, we are confident that the profiles on AdmitYogi are
              authentic — anything less, please reach out to us, and we will make sure you get the
              outmost value from our service or issue a refund.
            </AccordionPanel>
          </Box>
        )}
      </AccordionItem>

      <AccordionItem borderRadius="0.5rem" border="1px solid #6A7684" bg="#FFF" mt={5}>
        {({ isExpanded }) => (
          <Box
            sx={{
              boxShadow: isExpanded ? "-4px 4px 0px 0px #6A7684" : null,
              borderRadius: isExpanded ? "0.5rem" : null,
            }}
          >
            <chakra.h2>
              <AccordionButton _expanded={{ color: "#9559DE" }}>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  p={2}
                  fontSize="1.1875rem"
                  fontWeight={600}
                  fontFamily="Raleway, sans-serif"
                >
                  How do you prevent plagiarism?
                </Box>

                {isExpanded ? <MinusIcon fontSize="12px" /> : <AddIcon fontSize="12px" />}
              </AccordionButton>
            </chakra.h2>

            <AccordionPanel pb={4}>
              We take plagiarism seriously. Our team of moderators works hard to ensure that every
              essay on our platform is authentic, and we also incentivize our students to upload
              their acceptance letters. In the coming months, we plan on rolling out additional
              plagiarism detection measures, including novel detection software and collaboration
              with universities, so that our community can continue to remain plagiarism-free. We
              guarantee that the profiles on AdmitYogi are authentic and informative.
            </AccordionPanel>
          </Box>
        )}
      </AccordionItem>

      <AccordionItem borderRadius="0.5rem" border="1px solid #6A7684" bg="#FFF" mt={5}>
        {({ isExpanded }) => (
          <Box
            sx={{
              boxShadow: isExpanded ? "-4px 4px 0px 0px #6A7684" : null,
              borderRadius: isExpanded ? "0.5rem" : null,
            }}
          >
            <chakra.h2>
              <AccordionButton _expanded={{ color: "#9559DE" }}>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  p={2}
                  fontSize="1.1875rem"
                  fontWeight={600}
                  fontFamily="Raleway, sans-serif"
                >
                  Do you have other resources besides this platform?
                </Box>

                {isExpanded ? <MinusIcon fontSize="12px" /> : <AddIcon fontSize="12px" />}
              </AccordionButton>
            </chakra.h2>

            <AccordionPanel pb={4}>
              Yes! We have active TikTok and Instagram Pages, as well as Discord Community, where
              you can meet with peers and students who walked this admissions path before you.
            </AccordionPanel>
          </Box>
        )}
      </AccordionItem>

      <AccordionItem borderRadius="0.5rem" border="1px solid #6A7684" bg="#FFF" mt={5}>
        {({ isExpanded }) => (
          <Box
            sx={{
              boxShadow: isExpanded ? "-4px 4px 0px 0px #6A7684" : null,
              borderRadius: isExpanded ? "0.5rem" : null,
            }}
          >
            <chakra.h2>
              <AccordionButton _expanded={{ color: "#9559DE" }}>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  p={2}
                  fontSize="1.1875rem"
                  fontWeight={600}
                  fontFamily="Raleway, sans-serif"
                >
                  What if I unlock a profile that isn't helpful?
                </Box>

                {isExpanded ? <MinusIcon fontSize="12px" /> : <AddIcon fontSize="12px" />}
              </AccordionButton>
            </chakra.h2>

            <AccordionPanel pb={4}>
              No worries! While we are confident that most of our site&apos;s profiles are
              informative and relevant, bad apples occasionally fall through the cracks. If you
              found that a profile did not match its description as advertised, please{" "}
              <a href="/contact-us" style={{ textDecoration: "underline" }}>
                Contact Us
              </a>{" "}
              with your email address, a link to the profile, and a description of what you
              expected. We will analyze the report, and refund you accordingly!`,
            </AccordionPanel>
          </Box>
        )}
      </AccordionItem>

      <AccordionItem borderRadius="0.5rem" border="1px solid #6A7684" bg="#FFF" mt={5}>
        {({ isExpanded }) => (
          <Box
            sx={{
              boxShadow: isExpanded ? "-4px 4px 0px 0px #6A7684" : null,
              borderRadius: isExpanded ? "0.5rem" : null,
            }}
          >
            <chakra.h2>
              <AccordionButton _expanded={{ color: "#9559DE" }}>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  p={2}
                  fontSize="1.1875rem"
                  fontWeight={600}
                  fontFamily="Raleway, sans-serif"
                >
                  How do I find profiles most similar to my own?
                </Box>

                {isExpanded ? <MinusIcon fontSize="12px" /> : <AddIcon fontSize="12px" />}
              </AccordionButton>
            </chakra.h2>

            <AccordionPanel pb={4}>
              Our advanced search algorithm helps you sort applications by demographic data,
              academic interest, dream school, GPA, or any other criteria of your choosing. The
              result? Highly-individualized results, with accepted students whose college journeys
              may be similar to your own.
            </AccordionPanel>
          </Box>
        )}
      </AccordionItem>

      <AccordionItem borderRadius="0.5rem" border="1px solid #6A7684" bg="#FFF" mt={5}>
        {({ isExpanded }) => (
          <Box
            sx={{
              boxShadow: isExpanded ? "-4px 4px 0px 0px #6A7684" : null,
              borderRadius: isExpanded ? "0.5rem" : null,
            }}
          >
            <chakra.h2>
              <AccordionButton _expanded={{ color: "#9559DE" }}>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  p={2}
                  fontSize="1.1875rem"
                  fontWeight={600}
                  fontFamily="Raleway, sans-serif"
                >
                  Can I track my progress and usage on AdmitYogi to see how it's helping me with my
                  college applications?
                </Box>

                {isExpanded ? <MinusIcon fontSize="12px" /> : <AddIcon fontSize="12px" />}
              </AccordionButton>
            </chakra.h2>

            <AccordionPanel pb={4}>
              Yes, AdmitYogi stores your progress in a student dashboard. There, you can see all the
              profiles you have unlocked and all the essays you have revised.
            </AccordionPanel>
          </Box>
        )}
      </AccordionItem>

      <AccordionItem borderRadius="0.5rem" border="1px solid #6A7684" bg="#FFF" mt={5}>
        {({ isExpanded }) => (
          <Box
            sx={{
              boxShadow: isExpanded ? "-4px 4px 0px 0px #6A7684" : null,
              borderRadius: isExpanded ? "0.5rem" : null,
            }}
          >
            <chakra.h2>
              <AccordionButton _expanded={{ color: "#9559DE" }}>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  p={2}
                  fontSize="1.1875rem"
                  fontWeight={600}
                  fontFamily="Raleway, sans-serif"
                >
                  Can I use the AdmitYogi platform for free?
                </Box>

                {isExpanded ? <MinusIcon fontSize="12px" /> : <AddIcon fontSize="12px" />}
              </AccordionButton>
            </chakra.h2>

            <AccordionPanel pb={4}>
              Yes, high school students can access certain features of the AdmitYogi platform for
              free. We offer a free unlock so you can view a sample profile. We also offer a free
              evaluation for all your essays and a free acceptance rate calculator feature. However,
              to unlock more profiles or premium features of the Essay Revision tool - you need to
              purchase or earn credits. Please see the pricing option on the{" "}
              <a href="/plans" style={{ textDecoration: "underline" }}>
                Packages page
              </a>{" "}
              and learn how to earn credits with the Affiliate feature in your account dashboard.
            </AccordionPanel>
          </Box>
        )}
      </AccordionItem>

      <AccordionItem borderRadius="0.5rem" border="1px solid #6A7684" bg="#FFF" mt={5}>
        {({ isExpanded }) => (
          <Box
            sx={{
              boxShadow: isExpanded ? "-4px 4px 0px 0px #6A7684" : null,
              borderRadius: isExpanded ? "0.5rem" : null,
            }}
          >
            <chakra.h2>
              <AccordionButton _expanded={{ color: "#9559DE" }}>
                <Box
                  as="span"
                  flex="1"
                  textAlign="left"
                  p={2}
                  fontSize="1.1875rem"
                  fontWeight={600}
                  fontFamily="Raleway, sans-serif"
                >
                  I have a question that isn't answered here. How can I contact you?
                </Box>

                {isExpanded ? <MinusIcon fontSize="12px" /> : <AddIcon fontSize="12px" />}
              </AccordionButton>
            </chakra.h2>

            <AccordionPanel pb={4}>
              We're happy to assist you! Reach out to us on our{" "}
              <a href="/contact-us" style={{ textDecoration: "underline" }}>
                Contact Us
              </a>{" "}
              page, and we'll get back to you as soon as possible.
            </AccordionPanel>
          </Box>
        )}
      </AccordionItem>
    </Accordion>
  );
};
